import React, { useState } from 'react';
import { Modal, Button, Input, Typography, message } from 'antd';
import { SearchOutlined } from '@ant-design/icons';
import axios from 'axios';

const { Text } = Typography;

const VoucherModal = ({
  visible,
  setVisible,
  accessToken,
  idLoja,
  precoTotal,
  totalPago,
  setTotalPago,
  valor,
  setValor,
  pagamentos,
  setPagamentos,
  formaDePagamentoSelecionada,
  formasDePagamento,
  informacoesVoucher,
  setInformacoesVoucher
}) => {
  const [voucher, setVoucher] = useState('');

  const formatCurrency = (v) => {
    return parseFloat(v || 0).toLocaleString('pt-BR', {
      style: 'currency',
      currency: 'BRL',
    });
  };

  const buscarVoucher = async () => {
    try {
      const voucherTratado = voucher.replace(/\s+/g, '');

      const url = `${api.techspdv}/v1/voucher/token/${idLoja}/${voucherTratado}`;
      const options = {
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
          Authorization: 'Bearer ' + accessToken,
        },
      };
      const res = await axios.get(url, options);
      setInformacoesVoucher(res.data);
    } catch (err) {
      console.error(err);
      message.error('Erro ao buscar o voucher.');
    }
  };

  const confirmarVoucher = () => {
    const totalPagoAtual = parseFloat(totalPago);
    const valorVoucher = parseFloat(informacoesVoucher.valor || 0);
    const precoTotalNum = parseFloat(precoTotal);

    if (totalPagoAtual + valorVoucher <= precoTotalNum) {
      aplicarVoucher(valorVoucher);
    } else {
      if (formaDePagamentoSelecionada === "05") {
        const usar = precoTotalNum - totalPagoAtual;
        Modal.confirm({
          title: 'Confirmar Voucher',
          content: (
            <>
              <p>O voucher é maior que o valor da compra. Confirma o uso?</p>
              <p>Valor do voucher: {formatCurrency(valorVoucher)}</p>
              <p>Será usado: {formatCurrency(usar)}</p>
            </>
          ),
          okText: 'Sim',
          cancelText: 'Cancelar',
          onOk: () => aplicarVoucher(usar),
        });
      } else {
        message.warning('O valor do voucher excede o valor restante da compra.');
      }
    }
  };

  const aplicarVoucher = (valorAplicado) => {
    if (!formaDePagamentoSelecionada || !valorAplicado) return;

    const forma = formasDePagamento.find(f => f.value === formaDePagamentoSelecionada);
    if (!forma) return;

    const novoTotal = parseFloat(totalPago) + valorAplicado;
    setTotalPago(novoTotal);

    setPagamentos([
      ...pagamentos,
      {
        tipo: formaDePagamentoSelecionada,
        tipoNome: forma.label,
        valor: valorAplicado,
      },
    ]);

    const novoValor = precoTotal - novoTotal;
    setValor(formatCurrency(novoValor));
    setVisible(false);
  };

  return (
    <Modal
      title="Voucher"
      open={visible}
      onCancel={() => setVisible(false)}
      footer={null}
    >
      <div style={{ textAlign: 'center', marginBottom: 16 }}>
        <Text strong style={{ fontSize: 18 }}>Voucher</Text>
      </div>

      <div style={{ display: 'flex', gap: 8, marginBottom: 16 }}>
        <Input
          placeholder="Digite o voucher"
          value={voucher}
          onChange={(e) => setVoucher(e.target.value)}
        />
        <Button
          icon={<SearchOutlined />}
          type="primary"
          disabled={!(accessToken && idLoja && voucher)}
          onClick={buscarVoucher}
        />
      </div>

      <div style={{ textAlign: 'center', marginBottom: 10 }}>
        {informacoesVoucher.dt_criacao && (
          <Text>{new Date(informacoesVoucher.dt_criacao).toLocaleDateString('pt-BR')}</Text>
        )}
      </div>

      <div style={{ textAlign: 'center', marginBottom: 10 }}>
        <Text strong>{formatCurrency(informacoesVoucher.valor)}</Text>
      </div>

      <Button
        block
        type="primary"
        style={{ backgroundColor: informacoesVoucher.valor ? 'black' : 'grey' }}
        disabled={!informacoesVoucher.valor}
        onClick={confirmarVoucher}
      >
        Confirmar voucher
      </Button>
    </Modal>
  );
};

export default VoucherModal;
